import Cookies from "js-cookie";
import axios from "axios";
import qs from "querystring";
import { URLIDENTITY, API_URI } from './config';

//Opciones del header/enrutado
export const HREF = [
  { name: "Inicio", key: "menu_home", url: "/", internal: true },
  { name: "Mis Movimientos", key: "menu_movements", url: "/home/list-movements", internal: true },
  { name: "Regalos", key: "menu_gifts", url: "/home/list-gift", internal: true },
  { name: "Mis Datos", key: "menu_profile", url: "/home/profile", internal: true },
  {
    name: "Preguntas frecuentes",
    key: "menu_faq",
    url: "/home/frequent-question",
    internal: true
  },
  {
    name: "Contacto",
    key: "menu_contact",
    url: "https://www.ilusiona.com/contacto/",
    internal: false
  }
];

//FUNCTIONS
export function CHANGEVERSIONBUILD() {
  let pjson = require("../package.json");
  GETDATA('/Global/1', response => {
    if (pjson.version < response.data) {
      window.location.reload(true);
    }
  },()=>{},false);
}

export function HEADER(token = true) {
  if (token) {
    return {
      headers: {
        Authorization: "Bearer " + Cookies.get("iluToken"),
        "Access-Control-Allow-Origin": "*"
      }
    };
  } else {
    return {
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    };
  }
}

//Actualizacion del token del usuario para hacer peticiones
export function TOKENIDENTITY(refresh) {
  return new Promise((resolve, reject) => {
    axios.post(`${URLIDENTITY}/connect/token`,
      qs.stringify({
        grant_type: "client_credentials",
        client_secret: "secret",
        client_id: "client"
      }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*"
      }
    }).then(response => {
      if (refresh) {
        Cookies.set("iluToken", response.data.access_token, { expires: 1 });
      }
      resolve(
        {
          headers: {
            Authorization: "Bearer " + response.data.access_token,
            "Access-Control-Allow-Origin": "*"
          }
        }
      );
    });
  });
}

export function GETTOKEN() {
  if (Cookies.get("iluToken")) {
    return Cookies.get("iluToken");
  }
}

export function GETDATA(url, thenHandler, errorHandler, header) {
  return axios.get(API_URI + url, HEADER(header)
  ).then((response) => {
    thenHandler(response);
  }).catch((error) => {
    if (error) {
      if (error.response) {
        if (error.response.status === 401) {
          TOKENIDENTITY(true).then(v => {
            GETDATA(url, thenHandler, errorHandler);
          });
        } else {
          if (errorHandler) {
            errorHandler(error);
          }
        }
      }
    }
  });
}

export function POSTDATA(url, data, thenHandler, errorHandler) {
  return axios.post(API_URI + url, data, HEADER()
  ).then((response) => {
    thenHandler(response);
  }).catch((error) => {
    if (error) {
      if (error.response.status === 401) {
        TOKENIDENTITY(true).then(v => {
          POSTDATA(url, data, thenHandler, errorHandler);
        });
      } else {
        if (errorHandler) {
          errorHandler(error);
        }
      }
    }
  });
}

export function CALCULATEAGE(dob) {
  var diff_ms = Date.now() - dob.getTime();
  if (diff_ms > 0) {
    var age_dt = new Date(diff_ms);
    return Math.abs(age_dt.getUTCFullYear() - 1970);
  } else {
    return 0;
  }
}

export function CALCULATEDATEMORETHAN18() {
  const actualDate = new Date();
  return `${actualDate.getFullYear() - 18}-${
    actualDate.getMonth() < 10 ? "0" : ""
    }${actualDate.getMonth() + 1}-${
    actualDate.getDate() < 10 ? "0" : ""
    }${actualDate.getDate()}`;
}

export function CAPITALIZEFIRSTLETTER(word) {
  if (word) {
    let splitWord = word.split(" ");
    splitWord.forEach((split, index) => {
      if (split[0]) {
        splitWord[index] =
          split[0].toUpperCase() + split.slice(1).toLowerCase();
      }
    });
    return splitWord.join(" ");
  } else {
    return "";
  }
}

export function FORMATDATE(date) {
  if (date) {
    let d = new Date(date);
    let ret =
      (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) +
      "/" +
      (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
      "/" +
      d.getFullYear();
    return ret;
  } else {
    return "Sin fecha";
  }
}

export default function FORMATNUMBER(number, decimal = 0) {
  return number
    ? number
      .toFixed(decimal) // always two decimal digits
      .replace(".", ",") // replace decimal point character with ,
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    : "0";
}
